import { Avatar, Box, Button, Card, CardActions, CardContent, CssBaseline, Grid, ThemeProvider, Typography } from '@mui/material'
import React from 'react'
import { createTheme } from '@mui/material/styles';
import { Link, useNavigate } from 'react-router-dom';
import FestivalIcon from '@mui/icons-material/Festival';
import { useTranslation } from 'react-i18next';
import SnapSlider from './SnapSlider';

const defaultTheme = createTheme({
    typography: {
        fontFamily: '"Kanit", "Roboto", sans-serif',
        fontSize: 16,
    },
    palette: {
        primary: {
            main: '#007FFF',
            dark: '#0066CC',
        },
    },
});

function MainRouteTraval() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const icon = [
        { icon: "maptravel-Photoroom.png", label: t('tourist_places'), path: 'travels', placeType: 'tourist_attraction' },
        { icon: "home-Photoroom.png", label: t('heading_home_stay'), path: 'home-stay', placeType: 'hotel' },
        { icon: "food-Photoroom.png", label: t('heading_food'), path: 'food', placeType: 'restaurant' },
        { icon: "gift-Photoroom.png", label: t('heading_gift'), path: 'gift', placeType: 'gift_shop' },
        { icon: "market-Photoroom.png", label: t('heading_market'), path: 'market', placeType: 'community_product' },
    ];



    const handleNavigate = (item, index) => {
        // console.log("item", item);
        navigate(`/place/${item.path}`, {
            state: {
                type: 'banner_place',
                placeType: item.placeType,
                refName: 'place',
                label: item.label, // 👈 เพิ่ม label ที่ต้องการให้โชว์
            },
        });
    };
    // ปุ่มประเภทสถานที่ 1 อัน (ใช้ทั้งสไลด์มือถือและ grid จอใหญ่)
    const renderItem = (item, index) => (
                                <Box
                                    onClick={() => handleNavigate(item, index)}
                                    // component={Link}
                                    // to={`/place/${item.path}`} // ใช้ชื่อ label เป็น path เช่น /อาหาร
                                    sx={{
                                        textDecoration: 'none',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        p: 2,
                                        borderRadius: 4,
                                        color: "white",
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: '#006400', // เขียวเข้ม
                                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.2)',
                                            transform: 'scale(1.05)',
                                            color: "white",
                                        },
                                    }}
                                >
                                    <img
                                        // src={`/${item.icon}`}
                                        src={`/${item.icon}`}
                                        style={{
                                            width: '150px',
                                            filter: 'brightness(0) invert(1)',
                                            '&:hover': {
                                                filter: 'brightness(0) saturate(100%) sepia(100%) hue-rotate(75deg) brightness(1.2)',
                                            },
                                        }}
                                    />
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: { xs: '0.8rem', sm: '1rem' },
                                            mt: 1.5,
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
    );

    return (
        <ThemeProvider
            theme={defaultTheme}>
            <CssBaseline />
            <Box
                sx={{
                    width: '100%',
                    minWidth: 0, // เป็น flex item ใน MainPage — กันสไลด์ดันความกว้างเกินจอ
                    borderRadius: 2,
                    color: 'black',
                    px: { xs: 0, sm: 4 },
                    py: { xs: 3, sm: 5 },
                }}
            >
                {/* มือถือ: สไลด์ */}
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                    <SnapSlider slideWidth="min(60vw, 240px)" dotColor="#ffffff" dotIdleColor="rgba(255,255,255,0.45)">
                        {icon.map((item, index) => (
                            <Box key={index} sx={{ width: '100%', bgcolor: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 5, '& > div': { width: '100%', boxSizing: 'border-box', py: 3 } }}>
                                {renderItem(item, index)}
                            </Box>
                        ))}
                    </SnapSlider>
                </Box>

                {/* iPad / คอม: grid เดิม */}
                <Grid
                    container
                    spacing={3}
                    sx={{
                        display: { xs: 'none', sm: 'flex' },
                        pb: 2,
                        justifyContent: 'center',
                    }}
                >
                    {icon.map((item, index) => (
                        <Grid
                            item
                            key={index}
                            sx={{
                                minWidth: 300,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center', // ✅ จัดให้ทุกอย่างอยู่ตรงกลางแนวขวาง
                                textAlign: 'center',  // ✅ จัดข้อความให้อยู่กลาง
                            }}
                        >
                            {renderItem(item, index)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </ThemeProvider>

    )
}

export default MainRouteTraval